// Generated from SearchRegexLexer.g4 by ANTLR 4.8
// jshint ignore: start
import antlr4 from 'antlr4/index';



var serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
    "\u0002\t_\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004",
    "\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t\u0007",
    "\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0003\u0002\u0003\u0002\u0003\u0002",
    "\u0006\u0002\u0019\n\u0002\r\u0002\u000e\u0002\u001a\u0003\u0002\u0003",
    "\u0002\u0003\u0002\u0003\u0002\u0005\u0002!\n\u0002\u0003\u0003\u0006",
    "\u0003$\n\u0003\r\u0003\u000e\u0003%\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0005\u0003+\n\u0003\u0003\u0004\u0006\u0004.\n\u0004\r\u0004\u000e",
    "\u0004/\u0003\u0004\u0003\u0004\u0007\u00044\n\u0004\f\u0004\u000e\u0004",
    "7\u000b\u0004\u0003\u0005\u0006\u0005:\n\u0005\r\u0005\u000e\u0005;",
    "\u0003\u0005\u0003\u0005\u0007\u0005@\n\u0005\f\u0005\u000e\u0005C\u000b",
    "\u0005\u0003\u0006\u0003\u0006\u0007\u0006G\n\u0006\f\u0006\u000e\u0006",
    "J\u000b\u0006\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0007",
    "\u0007P\n\u0007\f\u0007\u000e\u0007S\u000b\u0007\u0003\b\u0003\b\u0003",
    "\t\u0003\t\u0003\n\u0006\nZ\n\n\r\n\u000e\n[\u0003\n\u0003\n\u0002\u0002",
    "\u000b\u0003\u0003\u0005\u0004\u0007\u0005\t\u0006\u000b\u0007\r\b\u000f",
    "\u0002\u0011\u0002\u0013\t\u0003\u0002\u0004\u0005\u0002\u000b\f\u000f",
    "\u000f\"\"\u0005\u0002\u000b\f\u000f\u000f\"#\u0002g\u0002\u0003\u0003",
    "\u0002\u0002\u0002\u0002\u0005\u0003\u0002\u0002\u0002\u0002\u0007\u0003",
    "\u0002\u0002\u0002\u0002\t\u0003\u0002\u0002\u0002\u0002\u000b\u0003",
    "\u0002\u0002\u0002\u0002\r\u0003\u0002\u0002\u0002\u0002\u0013\u0003",
    "\u0002\u0002\u0002\u0003 \u0003\u0002\u0002\u0002\u0005*\u0003\u0002",
    "\u0002\u0002\u0007-\u0003\u0002\u0002\u0002\t9\u0003\u0002\u0002\u0002",
    "\u000bD\u0003\u0002\u0002\u0002\rK\u0003\u0002\u0002\u0002\u000fT\u0003",
    "\u0002\u0002\u0002\u0011V\u0003\u0002\u0002\u0002\u0013Y\u0003\u0002",
    "\u0002\u0002\u0015\u0016\u0006\u0002\u0002\u0002\u0016\u0018\u0007*",
    "\u0002\u0002\u0017\u0019\t\u0002\u0002\u0002\u0018\u0017\u0003\u0002",
    "\u0002\u0002\u0019\u001a\u0003\u0002\u0002\u0002\u001a\u0018\u0003\u0002",
    "\u0002\u0002\u001a\u001b\u0003\u0002\u0002\u0002\u001b\u001c\u0003\u0002",
    "\u0002\u0002\u001c!\b\u0002\u0002\u0002\u001d\u001e\u0006\u0002\u0003",
    "\u0002\u001e\u001f\u0007*\u0002\u0002\u001f!\b\u0002\u0003\u0002 \u0015",
    "\u0003\u0002\u0002\u0002 \u001d\u0003\u0002\u0002\u0002!\u0004\u0003",
    "\u0002\u0002\u0002\"$\t\u0002\u0002\u0002#\"\u0003\u0002\u0002\u0002",
    "$%\u0003\u0002\u0002\u0002%#\u0003\u0002\u0002\u0002%&\u0003\u0002\u0002",
    "\u0002&\'\u0003\u0002\u0002\u0002\'+\u0007+\u0002\u0002()\u0006\u0003",
    "\u0004\u0002)+\u0007+\u0002\u0002*#\u0003\u0002\u0002\u0002*(\u0003",
    "\u0002\u0002\u0002+\u0006\u0003\u0002\u0002\u0002,.\t\u0002\u0002\u0002",
    "-,\u0003\u0002\u0002\u0002./\u0003\u0002\u0002\u0002/-\u0003\u0002\u0002",
    "\u0002/0\u0003\u0002\u0002\u000201\u0003\u0002\u0002\u000215\u0007(",
    "\u0002\u000224\t\u0002\u0002\u000232\u0003\u0002\u0002\u000247\u0003",
    "\u0002\u0002\u000253\u0003\u0002\u0002\u000256\u0003\u0002\u0002\u0002",
    "6\b\u0003\u0002\u0002\u000275\u0003\u0002\u0002\u00028:\t\u0002\u0002",
    "\u000298\u0003\u0002\u0002\u0002:;\u0003\u0002\u0002\u0002;9\u0003\u0002",
    "\u0002\u0002;<\u0003\u0002\u0002\u0002<=\u0003\u0002\u0002\u0002=A\u0007",
    "~\u0002\u0002>@\t\u0002\u0002\u0002?>\u0003\u0002\u0002\u0002@C\u0003",
    "\u0002\u0002\u0002A?\u0003\u0002\u0002\u0002AB\u0003\u0002\u0002\u0002",
    "B\n\u0003\u0002\u0002\u0002CA\u0003\u0002\u0002\u0002DH\u0007#\u0002",
    "\u0002EG\t\u0002\u0002\u0002FE\u0003\u0002\u0002\u0002GJ\u0003\u0002",
    "\u0002\u0002HF\u0003\u0002\u0002\u0002HI\u0003\u0002\u0002\u0002I\f",
    "\u0003\u0002\u0002\u0002JH\u0003\u0002\u0002\u0002KL\u0006\u0007\u0005",
    "\u0002LQ\u0005\u000f\b\u0002MN\u0006\u0007\u0006\u0002NP\u0005\u0011",
    "\t\u0002OM\u0003\u0002\u0002\u0002PS\u0003\u0002\u0002\u0002QO\u0003",
    "\u0002\u0002\u0002QR\u0003\u0002\u0002\u0002R\u000e\u0003\u0002\u0002",
    "\u0002SQ\u0003\u0002\u0002\u0002TU\n\u0003\u0002\u0002U\u0010\u0003",
    "\u0002\u0002\u0002VW\n\u0002\u0002\u0002W\u0012\u0003\u0002\u0002\u0002",
    "XZ\t\u0002\u0002\u0002YX\u0003\u0002\u0002\u0002Z[\u0003\u0002\u0002",
    "\u0002[Y\u0003\u0002\u0002\u0002[\\\u0003\u0002\u0002\u0002\\]\u0003",
    "\u0002\u0002\u0002]^\b\n\u0004\u0002^\u0014\u0003\u0002\u0002\u0002",
    "\u000e\u0002\u001a %*/5;AHQ[\u0005\u0003\u0002\u0002\u0003\u0002\u0003",
    "\b\u0002\u0002"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

function SearchRegexLexer(input) {
	antlr4.Lexer.call(this, input);
    this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.PredictionContextCache());

	  const CHAR_CODE = {
	    TAB: 9,
	    LF: 10,
	    CR: 13,
	    SPACE: 32,
	    LPAREN: 40,
	    RPAREN: 41,
	    LBRACKET: 91,
	    BACKSLASH: 92,
	    RBRACKET: 93,
	  };

	  const GROUPING_FALLBACK_DECISION = { isGrouping: false, closeIndex: -1 };

	  this._groupingParenDecisions = new Map();
	  this._groupingCloseIndexes = new Set();
	  this._criterionTokenScanState = undefined;

	  this._isWhitespace = function(code) {
	    return (
	      code === CHAR_CODE.SPACE ||
	      code === CHAR_CODE.TAB ||
	      code === CHAR_CODE.LF ||
	      code === CHAR_CODE.CR
	    );
	  };

	  this._isCurrentCharEscaped = function() {
	    let backslashCount = 0;

	    for (let offset = -1; ; offset -= 1) {
	      const code = this._input.LA(offset);

	      if (code !== CHAR_CODE.BACKSLASH) {
	        break;
	      }

	      backslashCount += 1;
	    }

	    return backslashCount % 2 === 1;
	  };

	  this._createScanState = function() {
	    return { isEscaped: false, charClassDepth: 0 };
	  };

	  this._advanceScanState = function(scanState, code) {
	    if (scanState.isEscaped) {
	      scanState.isEscaped = false;
	      return;
	    }

	    if (code === CHAR_CODE.BACKSLASH) {
	      scanState.isEscaped = true;
	      return;
	    }

	    if (code === CHAR_CODE.LBRACKET) {
	      scanState.charClassDepth += 1;
	      return;
	    }

	    if (code === CHAR_CODE.RBRACKET && scanState.charClassDepth > 0) {
	      scanState.charClassDepth -= 1;
	    }
	  };

	  // Grouping scan ignores escaped characters and anything inside character classes.
	  this._shouldSkipGroupingScanChar = function(scanState, code) {
	    const wasEscaped = scanState.isEscaped;
	    const wasInsideCharClass = scanState.charClassDepth > 0;
	    this._advanceScanState(scanState, code);
	    const isCharClassBoundary =
	      code === CHAR_CODE.LBRACKET || (code === CHAR_CODE.RBRACKET && wasInsideCharClass);
	    const isEscapeMarker = code === CHAR_CODE.BACKSLASH;

	    return wasEscaped || wasInsideCharClass || isEscapeMarker || isCharClassBoundary;
	  };

	  this._scanGroupingParenDecision = function(startIndex) {
	    let depth = 0;
	    let hasInnerWhitespace = false;
	    const scanState = this._createScanState();

	    for (let offset = 1; ; offset += 1) {
	      const code = this._input.LA(offset);

	      if (code <= 0) {
	        return { isGrouping: hasInnerWhitespace, closeIndex: -1 };
	      }

	      if (offset === 1) {
	        if (code !== CHAR_CODE.LPAREN) {
	          return GROUPING_FALLBACK_DECISION;
	        }

	        depth = 1;
	        continue;
	      }

	      if (this._shouldSkipGroupingScanChar(scanState, code)) {
	        continue;
	      }

	      if (this._isWhitespace(code)) {
	        hasInnerWhitespace = true;
	      }

	      if (code === CHAR_CODE.LPAREN) {
	        depth += 1;
	        continue;
	      }

	      if (code === CHAR_CODE.RPAREN) {
	        depth -= 1;

	        if (depth === 0) {
	          return {
	            isGrouping: hasInnerWhitespace,
	            closeIndex: startIndex + offset - 1,
	          };
	        }
	      }
	    }
	  };

	  this._getOrScanGroupingParenDecision = function(startIndex) {
	    if (!this._groupingParenDecisions.has(startIndex)) {
	      this._groupingParenDecisions.set(startIndex, this._scanGroupingParenDecision(startIndex));
	    }

	    return this._groupingParenDecisions.get(startIndex);
	  };

	  this._getGroupingParenDecisionAtCurrentIndex = function() {
	    return this._getOrScanGroupingParenDecision(this._input.index);
	  };

	  this.isGroupingLParen = function() {
	    if (this._isCurrentCharEscaped()) {
	      return false;
	    }

	    const decision = this._getGroupingParenDecisionAtCurrentIndex();
	    return Boolean(decision && decision.isGrouping);
	  };

	  this.registerGroupingLParen = function() {
	    const startIndex = this._tokenStartCharIndex;
	    const decision = this._getOrScanGroupingParenDecision(startIndex);

	    if (decision.isGrouping && decision.closeIndex >= 0) {
	      this._groupingCloseIndexes.add(decision.closeIndex);
	    }
	  };

	  this.isMarkedGroupingRParen = function() {
	    if (this._isCurrentCharEscaped()) {
	      return false;
	    }

	    return this._groupingCloseIndexes.has(this._input.index);
	  };

	  this._syncCriterionTokenScanState = function() {
	    const tokenStart = this._tokenStartCharIndex;
	    const currentIndex = this._input.index;

	    if (tokenStart < 0 || currentIndex <= tokenStart) {
	      this._criterionTokenScanState = undefined;
	      return undefined;
	    }

	    if (!this._criterionTokenScanState || this._criterionTokenScanState.tokenStart !== tokenStart) {
	      this._criterionTokenScanState = {
	        tokenStart,
	        lastProcessedIndex: tokenStart - 1,
	        scanState: this._createScanState(),
	      };
	    }

	    // Incrementally advance state only for characters not processed yet.
	    for (
	      let sourceIndex = this._criterionTokenScanState.lastProcessedIndex + 1;
	      sourceIndex < currentIndex;
	      sourceIndex += 1
	    ) {
	      const offsetFromCurrent = sourceIndex - currentIndex;
	      const code = this._input.LA(offsetFromCurrent);

	      if (code <= 0) {
	        break;
	      }

	      this._advanceScanState(this._criterionTokenScanState.scanState, code);
	      this._criterionTokenScanState.lastProcessedIndex = sourceIndex;
	    }

	    return this._criterionTokenScanState;
	  };

	  this._isInsideCharClassInCurrentToken = function() {
	    const tokenScanState = this._syncCriterionTokenScanState();
	    return Boolean(tokenScanState && tokenScanState.scanState.charClassDepth > 0);
	  };

	  this._canConsumeCriterionChar = function() {
	    const code = this._input.LA(1);

	    if (this._isInsideCharClassInCurrentToken()) {
	      return true;
	    }

	    if (code === CHAR_CODE.LPAREN || code === CHAR_CODE.RPAREN) {
	      if (this._isCurrentCharEscaped()) {
	        return true;
	      }

	      return code === CHAR_CODE.LPAREN
	        ? !this.isGroupingLParen()
	        : !this.isMarkedGroupingRParen();
	    }

	    return true;
	  };

	  // `CRITERION_START` and `CRITERION_CHAR` share the same paren-handling rules.
	  this.canStartCriterion = this._canConsumeCriterionChar;
	  this.canContinueCriterion = this._canConsumeCriterionChar;

    return this;
}

SearchRegexLexer.prototype = Object.create(antlr4.Lexer.prototype);
SearchRegexLexer.prototype.constructor = SearchRegexLexer;

Object.defineProperty(SearchRegexLexer.prototype, "atn", {
        get : function() {
                return atn;
        }
});

SearchRegexLexer.EOF = antlr4.Token.EOF;
SearchRegexLexer.LPAREN = 1;
SearchRegexLexer.RPAREN = 2;
SearchRegexLexer.AND = 3;
SearchRegexLexer.OR = 4;
SearchRegexLexer.NOT = 5;
SearchRegexLexer.CRITERION = 6;
SearchRegexLexer.WS = 7;

SearchRegexLexer.prototype.channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];

SearchRegexLexer.prototype.modeNames = [ "DEFAULT_MODE" ];

SearchRegexLexer.prototype.literalNames = [  ];

SearchRegexLexer.prototype.symbolicNames = [ null, "LPAREN", "RPAREN", "AND", 
                                             "OR", "NOT", "CRITERION", "WS" ];

SearchRegexLexer.prototype.ruleNames = [ "LPAREN", "RPAREN", "AND", "OR", 
                                         "NOT", "CRITERION", "CRITERION_START", 
                                         "CRITERION_CHAR", "WS" ];

SearchRegexLexer.prototype.grammarFileName = "SearchRegexLexer.g4";

SearchRegexLexer.prototype.action = function(localctx, ruleIndex, actionIndex) {
	switch (ruleIndex) {
	case 0:
		this.LPAREN_action(localctx, actionIndex);
		break;
	default:
		throw "No registered action for:" + ruleIndex;
	}
};


SearchRegexLexer.prototype.LPAREN_action = function(localctx , actionIndex) {
	switch (actionIndex) {
	case 0:
		 this.registerGroupingLParen(); 
		break;
	case 1:
		 this.registerGroupingLParen(); 
		break;
	default:
		throw "No registered action for:" + actionIndex;
	}
};
SearchRegexLexer.prototype.sempred = function(localctx, ruleIndex, predIndex) {
	switch (ruleIndex) {
		case 0:
			return this.LPAREN_sempred(localctx, predIndex);
		case 1:
			return this.RPAREN_sempred(localctx, predIndex);
		case 5:
			return this.CRITERION_sempred(localctx, predIndex);
    	default:
    		throw "No registered predicate for:" + ruleIndex;
    }
};

SearchRegexLexer.prototype.LPAREN_sempred = function(localctx, predIndex) {
	switch(predIndex) {
		case 0:
			return this.isGroupingLParen();
		case 1:
			return this.isGroupingLParen();
		default:
			throw "No predicate with index:" + predIndex;
	}
};

SearchRegexLexer.prototype.RPAREN_sempred = function(localctx, predIndex) {
	switch(predIndex) {
		case 2:
			return this.isMarkedGroupingRParen();
		default:
			throw "No predicate with index:" + predIndex;
	}
};

SearchRegexLexer.prototype.CRITERION_sempred = function(localctx, predIndex) {
	switch(predIndex) {
		case 3:
			return this.canStartCriterion();
		case 4:
			return this.canContinueCriterion();
		default:
			throw "No predicate with index:" + predIndex;
	}
};



export { SearchRegexLexer };

